(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ak-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ak-countdown')) {
    customElements.define(
      'ak-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        tick() {
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: this.dataset.tz || 'Europe/Stockholm',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23',
          }).formatToParts(new Date());
          const get = (type) => Number(parts.find((p) => p.type === type).value);
          let left = 86400 - (get('hour') * 3600 + get('minute') * 60 + get('second'));
          if (left <= 0) left = 86400;
          const pad = (n) => String(n).padStart(2, '0');
          const h = Math.floor(left / 3600);
          const m = Math.floor((left % 3600) / 60);
          const s = left % 60;
          this.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
